import { FC } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, ScrollRestoration } from "react-router";

import Sidebar from "../../components/Sidebar/Sidebar";
import GlobalLoader from "../../components/GlobalLoader/GlobalLoader";
import PageTracker from "../../components/PageTracker";
import { useAppSelector } from "../../hooks";
import { selectCommonLoading } from "../../store/selectors/common";
import { useMainLayoutData } from "./hooks/useMainLayoutData";
import { useSuperuserNavigate } from "../../hooks/useSuperuserNavigate";

import styles from "./MainLayout.module.css";

const MainLayout: FC = () => {
  useMainLayoutData();
  useSuperuserNavigate();
  const loading = useAppSelector(selectCommonLoading);

  return (
    <div className={styles["container"]}>
      <PageTracker />
      <aside className={styles["aside"]}>
        <Sidebar />
      </aside>
      <main>
        <Outlet />
        <ScrollRestoration />
      </main>
      {loading && <GlobalLoader />}
      <Toaster position="bottom-right" />
    </div>
  );
};

export default MainLayout;
